import {WidgetRegistry} from '@voltmoney/component';
import React, {useEffect} from 'react';
import {useWindowDimensions, View, StyleSheet} from 'react-native';
import {ROUTE_PLATFORM} from './utils/types';
import {isMobile} from '../partnerWeb/configs/util';
import {MicroFrontend} from '@voltmoney/platform';
import {ROUTE, ROUTE_MAP} from '@voltmoney/micro-frontend';
import {getLocalStorageSync, LocalStorageType} from "../partnerWeb/configs/localStorage";

const PlatformDashboardMF: React.FunctionComponent<{route: any}> = ({
  route,
}: any) => {
  const {width, height} = useWindowDimensions();
  const routeConfig =
    route.name === ROUTE_PLATFORM.LINKED_PARTNER
      ? ROUTE.PLATFORM_LINKED_PARTNERS
      : route.name === ROUTE_PLATFORM.LEADS
      ? ROUTE.PLATFORM_LEADS
      : route.name === ROUTE_PLATFORM.DASHBOARD
      ? ROUTE.PLATFORM_DASHBOARD
      : route.name === ROUTE_PLATFORM.ACTIVE_CUSTOMER
      ? ROUTE.PLATFORM_ACTIVE_CUSTOMERS
      : ROUTE.DASHBOARD;

  const _isMobile = isMobile();

  const styles = StyleSheet.create({
    dashBoardContainer: {
      width: '100%',
      height: height,
      alignItems: 'center',
      backgroundColor: !_isMobile ? 'rgb(242, 242, 242)' : '#FFFFFF',
    },
  });


  return (
      <View style={styles.dashBoardContainer}>
          <View
              style={{
                  width: width,
                  position: 'absolute',
                  height: 60,
                  borderColor: 'red',
                  backgroundColor: 'white',
              }}
          />
          <View
              style={{
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  maxWidth: 1600,
              }}>
              <MicroFrontend
                  routeMap={ROUTE_MAP}
                  routeCurrent={routeConfig ? routeConfig : ROUTE.PLATFORM_DASHBOARD}
                  widgetRegistry={WidgetRegistry}
                  extraProps={{
                      setIsUserLoggedIn: true,
                      partnerUserContext: getLocalStorageSync(
                          LocalStorageType.USER_CONTEXT,
                      ),
                      // dashboardActiveId: localStorage.getItem(
                      //   LocalStorageType.DASHBOARD_ACTIVE_ID,
                      // ),
                  }}
                  //@ts-ignore
                  width={'100%'}
                  height={height}
              />
          </View>
      </View>
  );
};

export default PlatformDashboardMF;
